import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faDownload,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getAllCalibrationIssueByDate,
  getCalibrationExcelDownload,
  getCalibrationList,
  getCalibrationReportPdf,
  getClibrationPdfDownload,
  getServiceCalibrationExcel,
} from "../../Service/AllServicesAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getCalibrationHistory } from "../../Service/AllReportAPI";
import { getCustomerList } from "../master/AllUserDropDown";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// import {
//     getWorkOrderFieldIssueList,
//   } from "../../Service/AllWorkOrderFieldIssueAPI";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  // --- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  let role = sessionStorage.getItem("role");

  useEffect(() => {
    getCalibrationHistoryList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // const getCalibrationListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // const getCalibrationListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    await getCalibrationHistory(selectedPage, fkUserId, role, headers)
      .then((result) => {
        console.log("Get Pagination Production Result", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
          setisLoaded(false);
        } else {
          setisLoaded(false);
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    console.log("entries", entries);
  };
  // Function declaration of get field visit list
  const getCalibrationHistoryList = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      // setisLoaded(true);
      await getCalibrationHistory(currentPage, fkUserId, role, headers)
        .then((result) => {
          setisLoaded(false);
          console.log("Work Order Calibration Result List", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
          }
          // console.log("setNoOfElements", noOfElements);
        })
        .catch((error) => {
          console.log("Work Order Calibration Error", error);
        });
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getCalibrationByDate = async () => {
    try {
      // setisLoaded(true);
      if (fromDate !== "" && toDate !== "") {
        await getAllCalibrationIssueByDate(
          currentPage,
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        )
          .then((result) => {
            setisLoaded(false);
            console.log("Get Date wise Field Issue Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
              setToDate("")
              setFromDate("")
            } else {
              setEntries([]);
              setPageCount();
              setTotalCount();
              setisLoaded(false);
              swal("Sorry", "Data is not present", "warning");
            }
            // console.log("setNoOfElements", noOfElements);
          })
          .catch((error) => {
            console.log("Get Field Issue Error", error);
          });
      } else {
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  const getCalibrationReportPdfDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        // setisLoaded(true);
        await getClibrationPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log(error);
        swal(
          "Failed",
          "Something went wrong please check your internet",
          "error"
        );
      }
    } else {
      try {
        // setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["pdf"];
        let jobType = ["calibration"];
        let role = sessionStorage.getItem("role");
        let fkUserId = sessionStorage.getItem("pkUserId");
        await getCalibrationReportPdf(token, fileType, role, fkUserId, jobType);
        setisLoaded(false);
        setToDate("")
        setFromDate("")
      } catch (error) {
        setisLoaded(false);
        console.log("getService calibration Pdf error :-", error);
      }
    }
  };

  const getCalibrationReportExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getCalibrationExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setToDate("")
        setFromDate("")
      } catch (error) {
        console.log("getFieldIssueWorkOrderExcelDownload error :-", error);
      }
    } else {
      try {
        let result = await getServiceCalibrationExcel();
        console.log("getServiceCalibration Excel result :-", result);
        setToDate("")
        setFromDate("")
        let blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocumnet.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "installationreportexcel.xlsx");
      } catch (error) {
        console.log("getServiceCalibration Excel error :-", error);
      }
    }
  };

  const concatDate = (cell, row) => {
    return `${moment(row.calibrationDate).format("DD-MMM-YYYY")} ${moment(
      row.calibrationTime,
      "HH:mm"
    ).format("hh:mm A")}`;
  };

  const calibrationCertificatePdf = (cell) => {
    console.log("calibrationCertificatePdf cell :-", cell);
    const newCell = cell.calibrationCertificate?.split(",");
    console.log("calibrationCertificatePdf newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<embed width="100%" height="100%" style={{padding: 0, margin: 0; boxSizing:'border-box'}} type="application/pdf" src="data:application/${newCell[0]};base64,${newCell[1]}"></embed>`
    );
  };

  const sendImage = (cell) => {
    console.log("sendImage cell :-", cell);
    const newCell = cell.certificateSignature?.split(",");
    console.log("sendImage newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src="data:image/${newCell[0]};base64,${newCell[1]}" />`
    );
  };

  const digitalSignatureImage = (cell) => {
    console.log("digitalSignatureImage cell :-", cell);
    const newCell = cell.digitalSignature?.split(",");
    console.log("digitalSignatureImage newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src="data:image/${newCell[0]};base64,${newCell[1]}" />`
    );
  };

  const siteReportUploadImage = (cell) => {
    console.log("siteReportUploadImage cell :-", cell);
    const newCell = cell.siteReportUpload?.split(",");
    console.log("siteReportUploadImage newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src="data:image/$newCell[0]};base64,${newCell[1]}" />`
    );
  };

  const sitePhotoImage = (cell) => {
    console.log("sitePhotoImage cell :-", cell);
    const newCell = cell.sitePhoto?.split(",");
    console.log("sitePhotoImage newCell :-", newCell);
    const newTab = window.open({ newCell });
    newTab.document.write(
      `<img src="data:image/${newCell[0]};base64,${newCell[1]}" />`
    );
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // Column heading of Field Visit list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "modelName",
      text: "Model Name",
      width: 100,
      editable: false,
      headerAlign: "left",
      formatter: (cell) => (!cell ? "NA" : cell),
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "calibrationDate",
      text: "Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "inspectorName",
      text: "Inspector Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "inspectorMobileNo",
      text: "Inspector Mobile No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "customerMobileNo",
      text: "Customer Mobile No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   width: 100,
    //   editable: false,
    //   headerAlign: "left",
    // },
    {
      dataField: "dealerMobileNo",
      text: "Dealer Mobile No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerName",
      text: "Service Engineer Name",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "description",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "ServiceEngineer Mobile No",
      width: 100,
      editable: false,
      headerAlign: "left",
    },
    // {
    //   dataField: "calibrationCertificate",
    //   text: "Calibration Certificate",
    //   editable: false,
    //   headerAlign: "left",
    //   formatter: (_, cell) => {
    //     return (
    //       <>
    //         <button
    //           className="btn btn-primary btn-sm"
    //           onClick={() => calibrationCertificatePdf(cell)}
    //           disabled={!cell.calibrationCertificate ? true : false}
    //         >
    //           View Pdf
    //         </button>
    //       </>
    //     );
    //   },
    // },
    // {
    //   dataField: "certificateSignature",
    //   text: "Certificate Signature",
    //   editable: false,
    //   headerAlign: "left",
    //   formatter: (_, cell) => {
    //     return (
    //       <>
    //         <button
    //           className="btn btn-primary btn-sm"
    //           onClick={() => sendImage(cell)}
    //           disabled={!cell.certificateSignature ? true : false}
    //         >
    //           View Image
    //         </button>
    //       </>
    //     );
    //   },
    // },
    // {
    //   dataField: "digitalSignature",
    //   text: "Digital Signature",
    //   editable: false,
    //   headerAlign: "left",
    //   formatter: (_, cell) => {
    //     return (
    //       <>
    //         <button
    //           className="btn btn-primary btn-sm"
    //           onClick={() => digitalSignatureImage(cell)}
    //           disabled={!cell.digitalSignature ? true : false}
    //         >
    //           View Image
    //         </button>
    //       </>
    //     );
    //   },
    // },
    {
      dataField: "calibrationLogView",
      text: "Calibration Log View",
      editable: false,
      headerAlign: "left",
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendImage(cell)}
              disabled={!cell.calibrationLogView ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
    },
    {
      dataField: "siteReportUpload",
      text: "Site Report Upload",
      editable: false,
      headerAlign: "left",
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => siteReportUploadImage(cell)}
              disabled={!cell.siteReportUpload ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
    },
    {
      dataField: "sitePhoto",
      text: "site Photo",
      editable: false,
      headerAlign: "left",
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sitePhotoImage(cell)}
              disabled={!cell.sitePhoto ? true : false}
            >
              View Image
            </button>
          </>
        );
      },
    },
    // {
    //   dataField: "longitude",
    //   text: "Longitude",
    //   editable: false,
    //   headerAlign: "left",
    // },
    // {
    //   dataField: "latitude",
    //   text: "Latitude",
    //   editable: false,
    //   headerAlign: "left",
    // },
    {
      dataField: "remark",
      text: "Remark",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "status",
      text: "Status",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
      },
    },
    {
      dataField: "startingOtpSendingTime",
      text: "Starting Otp Sending Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY hh:mm A")}</>;
      },
    },
    {
      dataField: "endingOtpSendingTime",
      text: "Ending Otp Sending Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY hh:mm A")}</>;
      },
    },
    {
      dataField: "timeTakenForCalibration",
      text: "Taken Time",
      width: 100,
      editable: false,
      headerAlign: "left",
      formatter: (cell) => (!cell ? "NA" : cell),
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          <Row>
            <Col className="d-block mb-4 mb-md-0">
              <h5 className="head mb-4">Calibration History Reports</h5>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-3">
              <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={3} className="mb-3">
              <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={3} className="mb-3">
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getCalibrationByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
          </Row>

          <Formik
            initialValues={{}}
            onSubmit={async (values) => {
              console.log(JSON.stringify(values, null, 2));
            }}
          >
            {(formik) => {
              return (
                <>
                  {/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                  <ToolkitProvider
                    keyField="id"
                    search={true}
                    columns={columns}
                    data={entries}
                    exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                  >
                    {({ baseProps, searchProps, csvProps }) => (
                      //render the Pagination component as a list with left and right arrows
                      <Paginator.PaginationProvider
                        pagination={Pagination({
                          custom: true,
                          alwaysShowAllBtns: true,
                          totalSize: totalCount,
                          disablePageTitle: true,
                          paginationTotalRenderer: customTotal,
                          onPageChange: (page) => {
                            handlePageChange(page);
                          },
                        })}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <Card>
                            <div className="table-responsive py-2">
                              <Card.Header>
                                <Row>
                                  <Col xs={12} md={6} className="py-1">
                                    {/* <Paginator.SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    /> */}
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end py-1"
                                  >
                                    <button
                                      className="btn btn-secondary"
                                      onClick={getCalibrationReportPdfDownload}
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>PDF</span>{" "}
                                    </button>
                                    <button
                                      className="btn btn-secondary mx-2"
                                      onClick={
                                        getCalibrationReportExcelDownload
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faDownload}
                                        className="me-2"
                                      />
                                      <span>Excel</span>
                                    </button>
                                  </Col>
                                </Row>
                              </Card.Header>
                              <Table
                                {...baseProps}
                                {...paginationTableProps}
                                bodyClasses="border-0"
                                rowClasses="border-bottom"
                                classes="table-flush dataTable-table"
                                // selectRow={selectRow}
                                filter={filterFactory()}
                                remote={{ pagination: true }}
                                headerClasses="header-class"
                                hover
                                striped
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                  afterSaveCell: (
                                    oldValue,
                                    newValue,
                                    row,
                                    column
                                  ) => {
                                    const changeRowData = {
                                      selectedRow: row,
                                      cellChange: newValue,
                                      columnChange: column,
                                    };
                                    setChangeRowData(changeRowData);
                                  },
                                })}
                                wrapperClasses="table-responsive"
                              />
                              <Card.Footer>
                                <Row>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex align-items-center py-1"
                                  ></Col>
                                  <Col
                                    xs={12}
                                    md={6}
                                    className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                  >
                                    <Paginator.PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </Col>
                                </Row>
                              </Card.Footer>
                            </div>
                          </Card>
                        )}
                      </Paginator.PaginationProvider>
                    )}
                  </ToolkitProvider>
                </>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};
// }};
